export class AuthPopupModel {
txtAuthPassword: string;
setValue(res){
if(res){
if(res['txtAuthPassword']){this.txtAuthPassword = res['txtAuthPassword'];}
}
}
}